import { render, staticRenderFns } from "./SingleContactCard.vue?vue&type=template&id=3d1f2362&scoped=true"
import script from "./SingleContactCard.vue?vue&type=script&lang=js"
export * from "./SingleContactCard.vue?vue&type=script&lang=js"
import style0 from "./SingleContactCard.vue?vue&type=style&index=0&id=3d1f2362&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1f2362",
  null
  
)

export default component.exports